<template>
  <div
    class="flex_box"
    :style="styleMerge"
  >
    <div class="current-active" />
    <div
      v-if="viewData.title"
      class="component-header"
    >
      <div
        class="component-title"
        :style="itemStyleMerge"
        :class="viewData.required ? 'required' : ''"
      >
        <div>{{ viewData.title }}</div>
        <div class="subtitle">
          {{ viewData.subtitle }}
        </div>
      </div>
      <div class="">
        <div class="three-dot" />
      </div>
    </div>
    <div class="city-select">
      <span class="icons el-icon-map-location" />
      <div class="content">
        {{ viewData.placeholder }}
      </div>
      <span class="icons el-icon-arrow-down" />
    </div>
  </div>
</template>
<script>
import formMixin from '@/view/weappTmp/core/lib/package/comps-node-mixin.js'
export default {
  name: 'SpSelectCity',
  mixins: [formMixin],
  props: {},
  data () {
    return {
      viewData: {}
    }
  },
  watch: {},
  created () {},
  methods: {}
}
</script>

<style scoped lang="scss">
@import '@/weappTmps/formTmps/index.scss';
.flex_box {
  // 纵向
  &_Vertical {
  }
  // 横向
  &_Horizontal {
    display: flex;
  }
  .city-select {
    display: flex;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: #ffffff;
    height: 36px;
    line-height: 36px;
    padding: 0 15px;
    color: #ddd;
    width: 100%;
    .icons {
      line-height: 36px;
    }
    .content {
      flex: 1;
      padding: 0 10px;
      color: #ddd;
      font-size: 14px;
      line-height: 36px;
    }
  }
}
</style>
